import React from 'react'

const NothingToShow = ({ title = '' }) => {
  return <p className='text-center'>{title}</p>
}

export default NothingToShow
